import { createSelector } from 'reselect'
import { entitySelector, resultsSelector } from 'containers/Entity/selectors'
import { getMonthDateYearTimestampString } from 'helpers/DateUtil'
import cloneDeep from 'lodash/cloneDeep'
import _ from 'lodash'







const nvqualDetailsEntitySelector = createSelector(
  entitySelector,
  (entities) => entities.project_nvqual_detail_views
    ? entities.project_nvqual_detail_views
    : {}
)

const projectNvqualSelector = state => state.project.projectNvqual

const nvqualDetailsChangeSelector = createSelector(
  projectNvqualSelector,
  (projectNvqual) => projectNvqual.nvqualDetailsChange
  ? projectNvqual.nvqualDetailsChange
  : {}
)

const nvqualDetailsSelectionEntitySelector = createSelector(
  entitySelector,
  (entities) => entities.nvqual_details_selections 
    ? entities.nvqual_details_selections
    : {}
)

const nvqualDetailsSelector = createSelector(
  nvqualDetailsEntitySelector,
  (entity) => {
    if(Object.values(entity)[0]){
      return Object.values(entity)[0]
    } else {
      return {}
    }
  }
)

const nvqualResultSourceIdSelector = createSelector(
  nvqualDetailsChangeSelector,
  (nvqualDetailsChange) => nvqualDetailsChange.nvqualResultSourceId != null
  ? nvqualDetailsChange.nvqualResultSourceId
  : ''
)

const nvqualResultSourceSelector = createSelector(
  nvqualDetailsChangeSelector,
  (nvqualDetailsChange) => nvqualDetailsChange.nvqualResultSource != null
  ? nvqualDetailsChange.nvqualResultSource
  : ''
)


const nvbugsIdSelector = createSelector(
  nvqualDetailsChangeSelector,
  (nvqualDetailsChange) => nvqualDetailsChange.nvbugId 
  ? nvqualDetailsChange.nvbugId
  : ''
)

const nvqualDetailsLastUpdatedNameSelector = createSelector(
  nvqualDetailsChangeSelector,
  (nvqualDetailsChange) => nvqualDetailsChange.lastUpdateUserName
  ? nvqualDetailsChange.lastUpdateUserName
  : ''
)

const nvqualDetailsLastUpdatedDateSelector = createSelector(
  nvqualDetailsChangeSelector,
  (nvqualDetailsChange) => nvqualDetailsChange.updatedAt
  ? getMonthDateYearTimestampString(new Date(nvqualDetailsChange.updatedAt))
  : ''
)

const nvqualResultSourcesOptionsSelector = createSelector(
  nvqualDetailsSelectionEntitySelector,
  (entity) => {
    if(Object.values(entity)[0] && Object.values(entity)[0].nvqualResultSources){
      var nvqualResultSources = Object.values(entity)[0].nvqualResultSources
      var toReturn = []
      Object.values(nvqualResultSources).forEach((nvqualResultSources) => {
        toReturn.push({ value: nvqualResultSources.id, label: nvqualResultSources.name })
      })
      return toReturn
    } else {
      return []
    }
  }
)

const nvqualDetailsParamsSelector = createSelector(
  nvqualResultSourceIdSelector,
  nvbugsIdSelector,
  (nvqualResultSourceId, nvbugId) => ({
    nvqualResultSourceId,
    nvbugId,
  })
)

const nvqualDetailsLoadingSelector = createSelector(
  projectNvqualSelector,
  (projectNvqual) => projectNvqual.loading
)


const curRevisionNumSelector = (state) => state.project.projectNvqual.curRevisionNumber
const revisionHeadersSelector = (state) => state.project.projectNvqual.revisionHeaders
const nvqualGlobalInfoSelector = (state) => state.project.projectNvqual.nvqual
const nvqualFetchLoadingSelector = (state) => state.project.projectNvqual.nvqualFetchLoading
const nvqualStatusSourceSelector = (state) => state.project.projectNvqual.nvqualStatusSource
const currentRevisionSelector = (state) => state.project.projectNvqual.currentRevision
const collapseSelector = (state) => state.project.projectNvqual.cardCollapse
const projectNvqualStatusSelector = (state) => state.project.projectNvqual.isClosed

const curRevisionIdSelector = createSelector(
  curRevisionNumSelector,
  revisionHeadersSelector,
  (num, headers) => {
    const curRevId = headers.find(x => x.revisionNumber == num)
    return curRevId && curRevId.id
  }
)

export {
  nvqualDetailsSelector,
  nvqualDetailsEntitySelector,
  nvqualResultSourceIdSelector,
  nvqualResultSourceSelector,
  nvbugsIdSelector,
  nvqualDetailsLastUpdatedNameSelector,
  nvqualDetailsLastUpdatedDateSelector,
  nvqualResultSourcesOptionsSelector,
  nvqualDetailsParamsSelector,
  nvqualDetailsLoadingSelector,
  curRevisionNumSelector,
  nvqualGlobalInfoSelector,
  nvqualFetchLoadingSelector,
  nvqualStatusSourceSelector,
  curRevisionIdSelector,
  currentRevisionSelector,
  revisionHeadersSelector,
  collapseSelector,
  projectNvqualStatusSelector
}
